import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { isEqual } from "lodash";
import {
  addTag,
  getTypes,
  getSingle
} from "actions/tag/actions";

class CreateNewTag extends Component {
  constructor(props) {
    super(props);

    this.handleSave = this.handleSave.bind(this);

    this.state = {
      tagSingle: {
        type: this.props.types.length ? this.props.types[0] : "",
        name: ""
      }
    };

    if (!this.props.types.length) {
      this.props.getTypes();
    }

    if (this.props.tagId) {
      this.props.getSingle(this.props.tagId);
    }
  }

  componentWillReceiveProps(nextProps) {
    let tagSingle = Object.assign({}, this.state.tagSingle);
    if (!isEqual(this.props.tagSingle, nextProps.tagSingle)) {
      tagSingle = nextProps.tagSingle;
    }
    if (!isEqual(this.props.types, nextProps.types)) {
      tagSingle.type = this.props.types[0];
    }

    this.setState({
      tagSingle
    });
  }

  componentWillUnmount() {
    if (this.props.tagId) {
      this.props.getSingle(false);
    }
  }

  handleSave = () => {
    const data = Object.assign({}, this.state.tagSingle);
    if (this.props.tagId) {
      data.id = this.props.tagId;
    }

    this.props.addTag(data, () => {
      this.props.onCancel();
    });
  };

  render() {
    const { types } = this.props;
    const {
      name,
      type
    } = this.state.tagSingle;

    return (
      <div>
        <div className="form-group">
          <label>Name</label>
          <input
            type="text"
            className="form-control"
            value={name}
            onChange={(ev) => {
              const tagSingle = Object.assign({}, this.state.tagSingle);
              tagSingle.name = ev.target.value;
              this.setState({
                tagSingle
              });
            }}
          />
        </div>
        <div className="form-group">
          <label>Type</label>
          <select
            value={type || ""}
            className="form-control"
            onChange={(ev) => {
              const tagSingle = Object.assign({}, this.state.tagSingle);
              tagSingle.type = ev.target.value;
              this.setState({
                tagSingle
              });
            }}
          >
            {types.map(item => (
              <option key={item} value={item}>{item}</option>
            ))}
          </select>
        </div>
        <div className="d-flex justify-content-between">
          <button
            className="btn btn-danger"
            onClick={this.props.onCancel}
          >
            Cancel
          </button>
          <button
            className="btn btn-success"
            onClick={this.handleSave}
          >
            Save
          </button>
        </div>
      </div>
    );
  }
}

CreateNewTag.propTypes = {
  tagId: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]).isRequired
};

const mapStateToProps = state => ({
  types: state.tag.types,
  tagSingle: state.tag.tagSingle
});

const mapStateToDispatch = dispatch => ({
  addTag: bindActionCreators(addTag, dispatch),
  getTypes: bindActionCreators(getTypes, dispatch),
  getSingle: bindActionCreators(getSingle, dispatch),
});

export default connect(
  mapStateToProps,
  mapStateToDispatch
)(CreateNewTag);



// WEBPACK FOOTER //
// ./src/views/pages/tag/create-new-tag.js